import { render } from "./Deals.vue?vue&type=template&id=9f70406e"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/Deals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f70406e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f70406e', __exports__)) {
    api.reload('9f70406e', __exports__)
  }
  
  module.hot.accept("./Deals.vue?vue&type=template&id=9f70406e", () => {
    api.rerender('9f70406e', render)
  })

}


export default __exports__